import hash = require("object-hash");
import _ = require("lodash");
import { CellType, ExcelColorValue, UploadStatus, Constants } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource } from "../../util/utils";

export class TemplateConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];
  apiTemplate: any;
  inputValidationRule: any;
  instructionSheetConfigurations: any;
  showAtlasLink: boolean;
  hideSummaryDetails: boolean;

  getMergeColumns = (columns: any[], entibasedConfigurations: IColumnConfig) => {
    let updatedColumns = [];
    let celldisplayIndex = 0;
    let templateBasedColumns = _.cloneDeep(columns); // Create a deep copy of columns
    if (entibasedConfigurations && entibasedConfigurations.columns) {
      entibasedConfigurations.columns.forEach((column) => {
        if (templateBasedColumns && templateBasedColumns.length) {
          let updatedColumnIndex = templateBasedColumns.findIndex((c) => c.CellId === column.CellId);
          if (updatedColumnIndex !== -1) {
            column = templateBasedColumns[updatedColumnIndex];

            templateBasedColumns.splice(updatedColumnIndex, 1);
          }
          let indexBasedColumn = templateBasedColumns.find((column) => column.CellDisplayIndex == celldisplayIndex);
          if (indexBasedColumn) {
            updatedColumns.push(indexBasedColumn);
            celldisplayIndex = celldisplayIndex + 1;
          }
        }
        column.CellDisplayIndex = celldisplayIndex;
        updatedColumns.push(column);
        celldisplayIndex++;
      });
    }

    // Remove the columns with Index from templateBasedColumns
    templateBasedColumns = templateBasedColumns?.filter((column) => !column.CellDisplayIndex);

    if (templateBasedColumns && templateBasedColumns.length) {
      // Add CellDisplayIndex to remaining templateBasedColumns and that in final list
      if (templateBasedColumns && templateBasedColumns.length) {
        templateBasedColumns.forEach((column) => {
          column.CellDisplayIndex = celldisplayIndex;
          updatedColumns.push(column);
          celldisplayIndex++;
        });
      }
    }

    return updatedColumns;
  };

  constructor(jsonTemplate: any, entibasedConfigurations: IColumnConfig) {
    if (!jsonTemplate) {
      this.columns = entibasedConfigurations.columns;
      this.rowheader = entibasedConfigurations.rowheader;
      this.showAtlasLink = entibasedConfigurations.showAtlasLink;
      this.hideSummaryDetails = entibasedConfigurations.hideSummaryDetails;
    } else {
      this.columns = jsonTemplate.columns
        ? this.getMergeColumns(jsonTemplate.columns, entibasedConfigurations)
        : entibasedConfigurations.columns;
      this.rowheader = jsonTemplate.rowheader ?? entibasedConfigurations.rowheader;
      this.showAtlasLink = jsonTemplate.showAtlasLink ?? entibasedConfigurations.showAtlasLink;
      this.hideSummaryDetails = jsonTemplate.hideSummaryDetails ?? entibasedConfigurations.hideSummaryDetails;
      this.apiTemplate = jsonTemplate.apiTemplate && jsonTemplate.apiTemplate;
      this.inputValidationRule = jsonTemplate.inputValidationRule && jsonTemplate.inputValidationRule;
      this.instructionSheetConfigurations =
        jsonTemplate.instructionSheetConfigurations && jsonTemplate.instructionSheetConfigurations;
    }
  }
}
